export const enum EOctaveType {
  ONE = 'ONE',
  TWO = 'TWO',
  THIRD = 'THIRD'
}

export enum EFreqOctaveOne {
  OCTAVE_0_5 = 'OCTAVE_0_5',
  OCTAVE_1 = 'OCTAVE_1',
  OCTAVE_2 = 'OCTAVE_2',
  OCTAVE_4 = 'OCTAVE_4',
  OCTAVE_8 = 'OCTAVE_8',
  OCTAVE_16 = 'OCTAVE_16',
  OCTAVE_31_5 = 'OCTAVE_31_5',
  OCTAVE_63 = 'OCTAVE_63',
  OCTAVE_125 = 'OCTAVE_125',
  OCTAVE_250 = 'OCTAVE_250',
  OCTAVE_500 = 'OCTAVE_500',
  OCTAVE_1000 = 'OCTAVE_1000',
  OCTAVE_2000 = 'OCTAVE_2000',
  OCTAVE_4000 = 'OCTAVE_4000',
  OCTAVE_8000 = 'OCTAVE_8000',
  OCTAVE_16000 = 'OCTAVE_16000',
  OCTAVE_31500 = 'OCTAVE_31500'
}

export enum EFreqOctaveTwo {
  OCTAVE_0_8 = 'OCTAVE_0_8',
  OCTAVE_2_5 = 'OCTAVE_2_5',
  OCTAVE_10 = 'OCTAVE_10',
  OCTAVE_40 = 'OCTAVE_40',
  OCTAVE_160 = 'OCTAVE_160',
  OCTAVE_800 = 'OCTAVE_800',
  OCTAVE_2500 = 'OCTAVE_2500',
  OCTAVE_10000 = 'OCTAVE_10000'
}

export enum EFreqOctaveThird {
  OCTAVE_0_4 = 'OCTAVE_0_4',
  OCTAVE_0_5 = 'OCTAVE_0_5',
  OCTAVE_0_63 = 'OCTAVE_0_63',
  OCTAVE_0_8 = 'OCTAVE_0_8',
  OCTAVE_1 = 'OCTAVE_1',
  OCTAVE_1_25 = 'OCTAVE_1_25',
  OCTAVE_1_6 = 'OCTAVE_1_6',
  OCTAVE_2 = 'OCTAVE_2',
  OCTAVE_2_5 = 'OCTAVE_2_5',
  OCTAVE_3_15 = 'OCTAVE_3_15',
  OCTAVE_4 = 'OCTAVE_4',
  OCTAVE_5 = 'OCTAVE_5',
  OCTAVE_6_3 = 'OCTAVE_6_3',
  OCTAVE_8 = 'OCTAVE_8',
  OCTAVE_10 = 'OCTAVE_10',
  OCTAVE_12_5 = 'OCTAVE_12_5',
  OCTAVE_16 = 'OCTAVE_16',
  OCTAVE_20 = 'OCTAVE_20',
  OCTAVE_25 = 'OCTAVE_25',
  OCTAVE_31_5 = 'OCTAVE_31_5',
  OCTAVE_40 = 'OCTAVE_40',
  OCTAVE_50 = 'OCTAVE_50',
  OCTAVE_63 = 'OCTAVE_63',
  OCTAVE_80 = 'OCTAVE_80',
  OCTAVE_100 = 'OCTAVE_100',
  OCTAVE_125 = 'OCTAVE_125',
  OCTAVE_160 = 'OCTAVE_160',
  OCTAVE_200 = 'OCTAVE_200',
  OCTAVE_250 = 'OCTAVE_250',
  OCTAVE_315 = 'OCTAVE_315',
  OCTAVE_400 = 'OCTAVE_400',
  OCTAVE_500 = 'OCTAVE_500',
  OCTAVE_630 = 'OCTAVE_630',
  OCTAVE_800 = 'OCTAVE_800',
  OCTAVE_1000 = 'OCTAVE_1000',
  OCTAVE_1250 = 'OCTAVE_1250',
  OCTAVE_1600 = 'OCTAVE_1600',
  OCTAVE_2000 = 'OCTAVE_2000',
  OCTAVE_2500 = 'OCTAVE_2500',
  OCTAVE_3150 = 'OCTAVE_3150',
  OCTAVE_4000 = 'OCTAVE_4000',
  OCTAVE_5000 = 'OCTAVE_5000',
  OCTAVE_6300 = 'OCTAVE_6300',
  OCTAVE_8000 = 'OCTAVE_8000',
  OCTAVE_10000 = 'OCTAVE_10000',
  OCTAVE_12500 = 'OCTAVE_12500',
  OCTAVE_16000 = 'OCTAVE_16000',
  OCTAVE_20000 = 'OCTAVE_20000',
  OCTAVE_25000 = 'OCTAVE_25000',
  OCTAVE_31500 = 'OCTAVE_31500',
  OCTAVE_40000 = 'OCTAVE_40000'
}
